import {create} from '@wix/fedops-logger';

export const fedopsLogger = create('music-get-window');
